var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "purchase-fish-content" },
      [
        _c(
          "div",
          { staticClass: "purchase-fish-header" },
          [
            _c(
              "router-link",
              { staticClass: "back-link", attrs: { to: "/mypage" } },
              [
                _c(_setup.ChevronLeftIcon, {
                  attrs: { size: 16, fillColor: "#67A9E7" },
                }),
                _vm._v(
                  " " + _vm._s(_setup.t("purchaseFish.backToMyPage")) + " "
                ),
              ],
              1
            ),
            _c("div", { staticClass: "purchase-fish-header-title" }, [
              _vm._v(_vm._s(_setup.t("purchaseFish.title"))),
            ]),
          ],
          1
        ),
        _setup.fishError
          ? _c("div", { staticClass: "fish-info fish-error" }, [
              _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_setup.fishError)),
              ]),
              _c(
                "button",
                {
                  staticClass: "retry-button",
                  on: { click: _setup.retryFetchFishData },
                },
                [
                  _vm._v(
                    _vm._s(_setup.t("purchaseFish.fishBalance.errorRetry"))
                  ),
                ]
              ),
            ])
          : _c("div", { staticClass: "fish-info" }, [
              _c("div", { staticClass: "fish-info-title" }, [
                _vm._v(_vm._s(_setup.t("purchaseFish.fishBalance.title"))),
              ]),
              _c("div", { staticClass: "fish-info-data" }, [
                _c(
                  "div",
                  { staticClass: "fish-info-data-title" },
                  [
                    _c("img", {
                      staticClass: "fish-info-data-title-icon",
                      attrs: {
                        src: require("@/assets/img/icon/fish_icon.png"),
                        alt: _setup.t("purchaseFish.product.fishIcon"),
                      },
                    }),
                    _setup.fishLoading
                      ? _c("span", {
                          staticClass: "skeleton-text skeleton-amount",
                        })
                      : [_vm._v(_vm._s(_setup.formattedCurrentFish))],
                  ],
                  2
                ),
                _c("div", { staticClass: "fish-info-data-description" }, [
                  _c(
                    "div",
                    { staticClass: "fish-info-data-description-item" },
                    [
                      _c("div", { staticClass: "fish-category" }, [
                        _vm._v(
                          _vm._s(_setup.t("purchaseFish.fishBalance.charge"))
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fish-value" },
                        [
                          _setup.fishLoading
                            ? _c("span", {
                                staticClass: "skeleton-text skeleton-value",
                              })
                            : [_vm._v(_vm._s(_setup.formattedPrepaidFish))],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "fish-info-data-description-item-plus" },
                    [_c(_setup.PlusIcon)],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "fish-info-data-description-item" },
                    [
                      _c("div", { staticClass: "fish-category" }, [
                        _vm._v(
                          _vm._s(_setup.t("purchaseFish.fishBalance.bonus"))
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fish-value" },
                        [
                          _setup.fishLoading
                            ? _c("span", {
                                staticClass: "skeleton-text skeleton-value",
                              })
                            : [_vm._v(_vm._s(_setup.formattedFreeFish))],
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
        _setup.isFreePlan
          ? _c("div", { staticClass: "premium-promotion-section" }, [
              _c(
                "a",
                {
                  staticClass: "premium-banner-link",
                  attrs: {
                    href: _vm.$router.resolve({ name: "subscriptionAnnounce" })
                      .href,
                  },
                  on: { click: _setup.onClickPremiumBanner },
                },
                [
                  _c("img", {
                    staticClass: "premium-banner-image",
                    attrs: {
                      src: _setup.bannerImageUrl,
                      alt: _setup.t("purchaseFish.premiumBannerAlt"),
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _setup.isLoading
          ? _c(_setup.LoadingSpinner, {
              attrs: {
                text: _setup.t("purchaseFish.loading"),
                size: "medium",
                variant: "inline",
              },
            })
          : _setup.error
          ? _c("div", { staticClass: "error-state" }, [
              _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_setup.error)),
              ]),
              _c(
                "button",
                {
                  staticClass: "retry-button",
                  on: { click: _setup.fetchFishProducts },
                },
                [_vm._v(_vm._s(_setup.t("purchaseFish.error.retry")))]
              ),
            ])
          : _c(
              "div",
              { staticClass: "fish-list" },
              _vm._l(_setup.fishList, function (fish) {
                return _c(
                  "div",
                  { key: fish.id, staticClass: "fish-list-item" },
                  [
                    _c("div", { staticClass: "fish-item-frame" }, [
                      _setup.calculateBonusFish(fish) > 0
                        ? _c("div", { staticClass: "fish-bonus-badge" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _setup.t(
                                    "purchaseFish.product.advantageBadge",
                                    {
                                      amount: _setup.formatNumber(
                                        _setup.calculateBonusFish(fish)
                                      ),
                                    }
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "fish-item-content" }, [
                        _c("img", {
                          staticClass: "fish-icon",
                          attrs: {
                            src: require("@/assets/img/icon/fish_icon.png"),
                            alt: _setup.t("purchaseFish.product.fishIcon"),
                          },
                        }),
                        _c("div", { staticClass: "fish-amount" }, [
                          _vm._v(
                            _vm._s(_setup.formatNumber(fish.amount)) +
                              " " +
                              _vm._s(_setup.t("purchaseFish.product.fish"))
                          ),
                        ]),
                        fish.bonus > 0
                          ? _c("div", { staticClass: "fish-bonus-info" }, [
                              _c("img", {
                                staticClass: "premium-icon",
                                attrs: {
                                  src: require("@/assets/img/icon/premium.png"),
                                  alt: _setup.t(
                                    "purchaseFish.product.premiumIcon"
                                  ),
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _setup.t(
                                      "purchaseFish.product.bonusWithAmount",
                                      {
                                        amount: _setup.formatNumber(fish.bonus),
                                      }
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "fish-item-button-frame" }, [
                      _c(
                        "button",
                        {
                          staticClass: "fish-item-button",
                          attrs: {
                            disabled: _setup.isLoading || _setup.fishLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _setup.onClickPurchase(fish)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " ¥ " +
                              _vm._s(_setup.formatNumber(fish.price)) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
        _c("div", { staticClass: "fish-list-footer" }, [
          _c("div", [
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_setup.t("purchaseFish.notes.note1")))]),
              _c("li", [_vm._v(_vm._s(_setup.t("purchaseFish.notes.note2")))]),
              _c("li", [_vm._v(_vm._s(_setup.t("purchaseFish.notes.note3")))]),
              _c("li", [_vm._v(_vm._s(_setup.t("purchaseFish.notes.note4")))]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "commercial-transactions-act-link" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/specifiedCommercialTransactionsAct",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_setup.t("purchaseFish.commercialTransactionsAct"))
                  ),
                ]
              ),
              _c("span", { staticClass: "link-separator" }, [_vm._v("|")]),
              _c(
                "router-link",
                { attrs: { to: "/paymentServicesAct", target: "_blank" } },
                [_vm._v(_vm._s(_setup.t("purchaseFish.paymentServicesAct")))]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }